import { render } from "./DataModal.vue?vue&type=template&id=1728e66a&ts=true"
import script from "./DataModal.vue?vue&type=script&lang=ts"
export * from "./DataModal.vue?vue&type=script&lang=ts"

import "./DataModal.vue?vue&type=style&index=0&id=1728e66a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__